import React from "react";
import "./greeting.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

const profilePhoto = `${process.env.PUBLIC_URL}/profile.png`;

export default function Greeting() {
  return (
    <section className="hero">
      <div className="hero-inner fade-up">
        <div className="hero-text">
          <span className="hero-eyebrow">Founding Engineer @ HiRobin</span>
          <h1 className="hero-name">Gopal Goyal</h1>
          <h2 className="hero-role">AI &amp; Full-Stack Engineer</h2>
          <p className="hero-bio">
            I build AI voice agents, agentic RAG systems, and full-stack products
            that serve users at scale. IIT Bombay alumnus.
          </p>

          <div className="hero-actions">
            <a href="/contact" className="btn btn-primary">
              <EmailIcon fontSize="small" /> Get in touch
            </a>
          </div>

          <div className="hero-socials">
            <a
              href="https://github.com/gopalgoyal2002"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/gopal-goyal-863981175/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
            <a href="mailto:gopalgoyal612002@gmail.com" aria-label="Email">
              <EmailIcon />
            </a>
          </div>
        </div>

        <div className="hero-photo">
          <img src={profilePhoto} alt="Gopal Goyal" />
        </div>
      </div>
    </section>
  );
}
